import styled, { keyframes } from "styled-components";
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const TOP_Z = 2147483647;

export const AlertBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: ${TOP_Z - 1};
`;

//CustomSeparator
export const Separator = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "1px"};
  background-color: ${(props) => props.backgroundColor || Colors.transparent};
`;

//Tittle Line
export const ContainerTittle = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  max-width: 100%;
  margin: 0 auto;
  padding: 0px;
`;

export const LineTittle = styled.hr`
  width: ${({ maxWidth }) => maxWidth || "950px"};
  @media (max-width: 768px) {
    width: auto;
  }
`;

//Space
export const StyledSpace = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -${(props) => props.size / 2}px;
`;

export const StyledSpaceItem = styled.div`
  padding: ${(props) => props.size / 2}px;
`;

// Spinner
export const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinnerWrapper = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: 3px solid ${(props) => props.colorBorder};
  border-top: 3px solid ${(props) => props.colorBorderTop};
  border-radius: 50%;
  animation: ${spinAnimation} 1s linear infinite;
`;

//Text
export const StyledText = styled.p`
  font-size: ${(props) => props.size || "16px"};
  color: ${(props) => props.color || "black"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-weight: ${(props) => props.weight || "normal"};
  margin: ${(props) => props.margin || ""};
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  &:hover {
    color: ${(props) => props.hoverColor || ""};
  }
  @media (max-width: 480px) {
    font-size: 10px;
  }
`;

//Tooltip
export const StyledTooltip = styled.div`
  position: relative;
  display: block;
  width: 100%;
  cursor: default;
`;

export const StyledTooltipContent = styled.div`
  visibility: hidden;
  position: absolute;
  z-index: 9999;
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  padding: 8px;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;

  ${StyledTooltip}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

//Avatar
export const Avatar = styled.img`
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-right: 20px;
  margin-top: 25px;
`;

//Warning
export const AlertWarning = styled.div`
  background-color: #fff3cd !important;
  border: 1px solid ${(props) => props.colorBorder || Colors.warning};
  border-radius: 8px;
  padding: 15px;
`;

//Alert
export const AlertContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);

  z-index: ${TOP_Z};
  display: flex;
  align-items: center;
  flex-direction: column;

  width: auto;
  max-width: ${(props) => props.maxWidth || "500px"};
  min-width: 300px;
  height: auto;
  box-sizing: border-box;
  @media (max-width: 844px) {
    top: 50%;
    left: 25%;
    max-width: 90%;
    min-width: 250px;
  }
`;

export const AlertContent = styled.div`
  align-items: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  white-space: pre-line;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  width: 100%;
`;

export const AlertButtonContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
`;

//ModalLoader
export const ModalLoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;